"use client";

import { useRef } from "react";
import { useInView, type UseInViewOptions } from "motion/react";


export function useInViewObserver<T extends HTMLElement = HTMLElement>(options?: UseInViewOptions) {
  const ref = useRef<T>(null);

  const inView = useInView(ref, options ?? {
    margin: "-100px",
    once: true,
  });

  return {
    ref,
    inView,
  };
}
